<app-dialog
	[modalTitle]="data.isCongener ? 'Benefícios Congênere' : 'Benefícios'"
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	[noMargins]="true"
	[disabled]="form.invalid"
	(dialogClose)="closeModal()"
	(dialogSave)="onContinue()"
>
	<ng-container *ngIf="isLoading">
		<div class="d-f jc-c ai-c w-100 mt-giant">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	</ng-container>
	<ng-container *ngIf="!isLoading">
		<div class="w-100 h-100 container" [formGroup]="form">
			<div class="mt-xxs ml-xxs mb-s">
				<mat-slide-toggle formControlName="showConjugated">
					Benefício Conjugado
				</mat-slide-toggle>
			</div>

			<ng-container *ngIf="!form.get('showConjugated')?.value">
				<div class="d-f mt-xxxs ml-xxxs line">
					<mat-form-field
						class="mr-xxxs col-1"
						title="Plano de saúde"
						appearance="outline"
					>
						<mat-label>Plano de saúde</mat-label>
						<mat-select
							formControlName="health_plan"
							(valueChange)="updateForm('health', $event)"
							(selectionChange)="validateUpdatedData('health')"
						>
							<mat-option *ngFor="let ben of healthBenefits" [value]="ben?.id">
								{{ ben?.name }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="form.get('health_plan')?.hasError('required')">
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Carteirinha de saúde"
						appearance="outline"
					>
						<mat-label>Carteirinha de saúde</mat-label>
						<input
							type="text"
							matInput
							placeholder="Carteirinha de saúde"
							formControlName="health_card"
							id="skh-{{ inputId }}"
							(change)="validateUpdatedData('health')"
						/>
						<mat-error *ngIf="form.get('health_card')?.hasError('required')">
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Início de Vigência"
						appearance="outline"
					>
						<mat-label>Início de Vigência</mat-label>
						<input
							matInput
							placeholder="Início de Vigência"
							formControlName="healthDate"
							[matDatepicker]="picker"
						/>
						<mat-datepicker-toggle matSuffix [for]="picker">
							<mat-icon
								matDatepickerToggleIcon
								svgIcon="sanus-calendar-blue"
							></mat-icon>
						</mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
						<mat-error *ngIf="form.get('healthDate')?.hasError('required')">
							Campo obrigatório
						</mat-error>
					</mat-form-field>
				</div>
				<div class="d-f mt-xxxs ml-xxxs line">
					<mat-form-field
						class="mr-xxxs col-1"
						title="Plano dental"
						appearance="outline"
					>
						<mat-label>Plano dental</mat-label>
						<mat-select
							formControlName="dental_plan"
							(valueChange)="updateForm('dental', $event)"
							(selectionChange)="validateUpdatedData('dental')"
						>
							<mat-option *ngFor="let ben of dentalBenefits" [value]="ben?.id">
								{{ ben?.name }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="form.get('dental_plan')?.hasError('required')">
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Carteirinha dental"
						appearance="outline"
					>
						<mat-label>Carteirinha dental</mat-label>
						<input
							type="text"
							matInput
							placeholder="Carteirinha dental"
							formControlName="dental_card"
							id="skd-{{ inputId }}"
							(change)="validateUpdatedData('dental')"
						/>
						<mat-error *ngIf="form.get('dental_card')?.hasError('required')">
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Início de Vigência"
						appearance="outline"
					>
						<mat-label>Início de Vigência</mat-label>
						<input
							matInput
							placeholder="Início de Vigência"
							formControlName="dentalDate"
							[matDatepicker]="pickerb"
						/>
						<mat-datepicker-toggle matSuffix [for]="pickerb">
							<mat-icon
								matDatepickerToggleIcon
								svgIcon="sanus-calendar-blue"
							></mat-icon>
						</mat-datepicker-toggle>
						<mat-datepicker #pickerb></mat-datepicker>
						<mat-error *ngIf="form.get('dentalDate')?.hasError('required')">
							Campo obrigatório
						</mat-error>
					</mat-form-field>
				</div>
			</ng-container>

			<ng-container *ngIf="form.get('showConjugated')?.value">
				<div class="d-f mt-xxxs ml-xxxs line">
					<mat-form-field
						class="mr-xxxs col-1"
						title="Plano conjugado"
						appearance="outline"
					>
						<mat-label>Plano conjugado</mat-label>
						<mat-select
							formControlName="conjugated_plan"
							(valueChange)="updateForm('conjugated', $event)"
							(selectionChange)="validateUpdatedData('conjugated')"
						>
							<mat-option
								*ngFor="let ben of conjugatedBenefits"
								[value]="ben?.id"
							>
								{{ ben?.name }}
							</mat-option>
						</mat-select>
						<mat-error
							*ngIf="form.get('conjugated_plan')?.hasError('required')"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Carteirinha conjugada"
						appearance="outline"
					>
						<mat-label>Carteirinha conjugada</mat-label>
						<input
							type="text"
							matInput
							placeholder="Carteirinha conjugada"
							formControlName="conjugated_card"
							id="skconj-{{ inputId }}"
							(change)="validateUpdatedData('conjugated')"
						/>
						<mat-error
							*ngIf="form.get('conjugated_card')?.hasError('required')"
						>
							Campo obrigatório
						</mat-error>
					</mat-form-field>
					<mat-form-field
						class="mr-xxxs col-1"
						title="Início de Vigência Conjugado"
						appearance="outline"
					>
						<mat-label>Início de Vigência</mat-label>
						<input
							matInput
							placeholder="Início de Vigência"
							formControlName="conjugatedDate"
							[matDatepicker]="pickerConjugated"
						/>
						<mat-datepicker-toggle matSuffix [for]="pickerConjugated">
							<mat-icon
								matDatepickerToggleIcon
								svgIcon="sanus-calendar-blue"
							></mat-icon>
						</mat-datepicker-toggle>
						<mat-datepicker #pickerConjugated></mat-datepicker>
						<mat-error *ngIf="form.get('conjugatedDate')?.hasError('required')">
							Campo obrigatório
						</mat-error>
					</mat-form-field>
				</div>
			</ng-container>
		</div>
	</ng-container>
</app-dialog>
